/**
 * EAP coverage skeleton
 */

import {
  BaseBenefitPlanPolicyPeriod,
  RfpInclusionStatusEnum,
  RfpTiedToAnotherLocEnum,
} from "@platform/openapi-types";

import {
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getEapSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.EAP,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "eap-plan-1",
      name: "Employee Assistance Program",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.newBusiness,
      currentCarrierName: "",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "eap",

        // Face to Face Visits
        faceToFaceVisits: 0,

        // Per Occurrence Per Year
        perOccurrencePerYear: "",

        // Legal & Financial Resources
        legalFinancialResources: "",

        // Employer Contribution
        employerContribution: undefined,

        // Unlimited Telephonic
        unlimitedTelephonic: RfpInclusionStatusEnum.notIncluded,

        // Tied to Another LOC
        tiedToAnotherLoc: RfpTiedToAnotherLocEnum.notIncluded,

        // Extended (non-v5) field
        additionalResourcesIncluded: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
